import * as balancesAPI from '../../lib/api/balances'
import * as loadingActions from './loading'

export const RECEIVE_BALANCES = 'BALANCES_RECEIVE'
export const RECEIVE_SAVINGS = 'BALANCES_SAVINGS_RECEIVE'
export const RECEIVE_WITHDRAWN_BALANCES = 'BALANCES_WITHDRAWALS'

export function fetchBalances(){
	return dispatch => loadingActions.promise(
		dispatch,
		RECEIVE_BALANCES,
		balancesAPI.fetchBalances().then(
			data => dispatch(_receiveBalances(data))
		)
	)
}

function _receiveBalances(data){
	return {
		type: RECEIVE_BALANCES,
		available: data.available,
		savings: data.savings,
		account: data.account
	}
}

export function fetchSavingStreams(){
	return dispatch => loadingActions.promise(
		dispatch,
		RECEIVE_SAVINGS,
		balancesAPI.fetchSavingStreams()
			.then(data => {
				dispatch(_receiveSavingsStreams(data.streams))
				dispatch(_receiveAmountWithdrawnToday(data.amountWithdrawnToday))
			})
	)
}

function _receiveSavingsStreams(streams){
	return {
		type: RECEIVE_SAVINGS,
		streams: streams
	}
}

function _receiveAmountWithdrawnToday(amountWithdrawnToday){
	return {
		type: RECEIVE_WITHDRAWN_BALANCES,
		amountWithdrawnToday: amountWithdrawnToday
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/balances.js